function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6003,
    y1: 10.4032,
    x2: 29.1169,
    y2: 42.7359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F44F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    style: {
      stopColor: "#EE3D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E52030"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M36.277,15.251C39.276,18.384,41,22.571,41,27c0,9.374-7.626,17-17,17S7,36.374,7,27 c0-8.518,8.812-15.984,15.894-21.983c0.379-0.321,0.74-0.629,1.106-0.941v5.25C17.865,14.559,11,20.837,11,27 c0,7.168,5.832,13,13,13s13-5.832,13-13c0-3.428-1.363-6.657-3.709-9.062L36.277,15.251z M30,10c-1.105,0-2,0.895-2,2s0.895,2,2,2 s2-0.895,2-2S31.105,10,30,10z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.6ef05d5458198a053f4d69aab2648d76.svg";
export { ForwardRef as ReactComponent };